import React from "react";
import ATMMarkdownContainer from "src/components/UI/atoms/ATMMarkdownContainer/ATMMarkdownContainer";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import AccordianFormLayout from "src/components/layouts/AccordianFormLayout/AccordianFormLayout";
import AssigmentLayout from "../AssigmentLayout/AssigmentLayout";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const StudentAssignmentListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
    <div className="flex flex-col h-full">
      {/* Page Header */}
      <div className="p-4">
        <ATMPageHeader
          pageTitle="Student-Assignments"
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          hideAddButton
        />
      </div>

      {/* Table */}
      {isTableLoading ?  <div>
      {Array(4)
        .fill(0)
        .map((_, index) => {
          return (
            <div key={index} className="animate-pulse  h-[50px] p-2">
              <div className="bg-slate-200 h-full rounded"> </div>
            </div>
          );
        })}{" "}
    </div> :rows?.map((el: any, ind: any) => {
        return (
          <div className="m-1" key={ind}>
            <AccordianFormLayout
              formHeading={
                <div className="line-clamp-2 text-base cursor-pointer text-primary-dark">
                  <ATMMarkdownContainer markdown={el?.question} />
                </div>
              }
            >
              <div>
                <AssigmentLayout data={el?.assignment} />
              </div>
            </AccordianFormLayout>
          </div>
        );
      })}

      <div className="p-4 py-2 flex justify-end">
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default StudentAssignmentListing;
